import { Component, inject, OnInit } from '@angular/core';
import { orgSchema } from '../organization.interface';
import { OrgMode } from '../organization.enums';
import { DRAWER_IDS } from '../../../core/constants/drawer-ids.constant';
import { DrawerService } from '../../../core/services/drawer.service';
import { finalize, Subject, takeUntil } from 'rxjs';
import { NzTableModule, NzTableQueryParams } from 'ng-zorro-antd/table';
import { OrganizationService } from '../organization.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-local-administrators',
  standalone: true,
  imports: [NzTableModule, CommonModule],
  templateUrl: './local-administrators.component.html',
})
export class LocalAdministratorsComponent implements OnInit {
  private readonly organizationService = inject(OrganizationService);
  private readonly drawerService = inject(DrawerService);
  localadmins$ = this.organizationService.localadmins$;
  orgParams: orgSchema = {
    organizationId: 0,
    mode: OrgMode.VIEW,
  };
  private readonly destroy$ = new Subject<void>();
  loading = false;
  errorMessage = '';
  sortOrder: number | undefined = undefined;
  constructor() {
    this.setupDrawerParams();
  }

  ngOnInit(): void {
    this.loadData();
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    if (currentSort) {
      this.sortOrder = currentSort.value === 'ascend' ? 1 : 0;
    } else {
      this.sortOrder = undefined;
    }

    this.loadData();
  }

  loadData(): void {
    this.loading = true;

    this.organizationService
      .getLocalAdmins({
        sortOrder: this.sortOrder,
        organizationId: this.orgParams.organizationId,
      })
      .pipe(
        finalize(() => (this.loading = false)),
        takeUntil(this.destroy$)
      )
      .subscribe({
        error: (error: Error) => {
          this.errorMessage = error.message;
          setTimeout(() => (this.errorMessage = ''), 3000);
        },
      });
  }
  private setupDrawerParams(): void {
    this.drawerService
      .getParams<orgSchema>(DRAWER_IDS.ADMINISTRATOR)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.orgParams = params;
        }
      });
  }
}
